import { Box } from "@mui/material";

import { GreyPallet } from "../../../../../config/styles";

import useBus from "../../context";

export default function HolidayBanner() {
  const { weekDay } = useBus();

  // TODO: Passar isso para os banners no BusScheduleInfoType e testar o banner no domingo
  return weekDay === "6" ? (
    <Box style={{ backgroundColor: GreyPallet.Light, borderRadius: 15 }} p={2} mb={4}>
      Aos sábados os horários podem variar!
    </Box>
  ) : weekDay === "0" ? (
    <>
      <Box style={{ backgroundColor: GreyPallet.Light, borderRadius: 15 }} p={2} mb={2}>
        No domingo não há Circular no campus!
      </Box>
      <Box style={{ backgroundColor: GreyPallet.Light, borderRadius: 15 }} p={2} mb={4}>
        No entando, se houver algum evento (Como Provas e Concursos) alguns ônibus podem sair
        fazendo a rota do Direto, geralmente com intervalos de 40 minutos.
      </Box>
    </>
  ) : null;
}
